import { useEffect } from 'react';
import libraryReducer from '../store';
import librarySagaWatcher from '@pages/library/store/sagas';
import { injectSaga } from '@app/store/rootSaga';
import { injectReducer } from '@app/store';

export const useLibraryChunk = () => {
    useEffect(() => {
        injectReducer('library', libraryReducer);
        injectSaga('library', librarySagaWatcher);
    }, []);
};
